import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getFountainTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}fountaintype`);
      let data = response["data"];
      context.commit("updateFountainTypesData", data);
    },
    async createFountainTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}fountaintype/store`, body, config);
      context.dispatch("getFountainTypesData");
    },
    async pushFountainTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}fountaintype/update`, body, config);
      context.dispatch("getFountainTypesData");
    },
    async destroyFountainTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}fountaintype/destroy`, body, config);
      context.dispatch("getFountainTypesData");
    }
  },
  mutations: {
    updateFountainTypesData(state, fountainTypesData) {
      state.fountainTypesData = fountainTypesData;
    }
  },
  state: {
    fountainTypesData: []
  },
  getters: {
    allFountainTypesData(state) {
      return state.fountainTypesData;
    }
  }
};
